import axios from 'axios/index'
import {loading, setSessionId} from '../util/util.js'
import store from '../store/store.js'

// http request拦截器
axios.interceptors.request.use(
  config => {
    loading.show()
    return config
  },
  error => {
    return Promise.reject(error.response)
  })

// http response拦截器
axios.interceptors.response.use(
  response => {
    if (response.data && response.data.errCode === 305) { // 请重新登录
      store.commit('setLoginAccount', null)
    } else if (response.data && response.data.errCode === 0) {
      if (response.data.sessionid) {
        setSessionId(response.data.sessionid)
      }
    }
    loading.hide()
    return response
  },
  error => {
    loading.hide()
    return Promise.reject(error.response)
  }
)

export default axios



// WEBPACK FOOTER //
// ./src/axios/axios.js